import React, { Component } from "react"
import Hidable from "../Hidable"
import Spacer from "../Spacer"
import Card from "../../components/Card"
import LabeledValue from "../../components/LabeledValue"
import * as utils from "../../utils"

import styles from "./styles.css"


class DebtPhaseMbReference extends Component {
  props: {
    mbReference: any,
  }

  render () {
    const {mbReference} = this.props;
    return (
      <Hidable
        title={"Referência Multibanco"}
      >
        <Card decor className={styles.card}>
            <LabeledValue label={"Entidade"}>
              {mbReference.entity}
            </LabeledValue>
            <LabeledValue label={"Referência"}>
              {mbReference.reference}
            </LabeledValue>
            <LabeledValue label={"Valor"}>
              {utils.formatCurrency(mbReference.value)}
            </LabeledValue>
        </Card>
      </Hidable>
    )
  }
}

export default DebtPhaseMbReference;



// WEBPACK FOOTER //
// ./src/components/DebtPhaseMbReference/index.jsx